<template>
  <div>
    <datatable
      :is_createable="false"
      title="Applicant Questions"
      @edit_click="editClick"
      @delete="deleteQuestion"
      :fields="fields"
      :response="data"
    >
    </datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'applicants-questions',
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      applicant_id: this.$route.query.applicant_id,
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'designator',
          value: 'designator',
          css_classes: {
            mandatory_question: (row_data) => ['interview_score', 'seniority', 'job_title'].includes(row_data.designator)
          }
        },
        {
          name: 'applicant_text',
          value: 'info.applicant_text'
        },
        {
          name: 'answers',
          value: 'answers'
        }
      ],
      data: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceQuestions({
          current_type: 'Applicant',
          current_resource_id: this.applicant_id,
          designators: this.questions_helper.getAllDesignators()
        })
        .then(response => {
          this.data = this.questions_helper.getQuestionsWithAnswers(response)
        })
    },
    deleteQuestion (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.designator,
        item_name: delete_data.designator,
        method: 'postQuestionAnswer',
        method_params: { question_id: delete_data.id, current_type: 'Applicant', current_resource_id: this.applicant_id, option_ids: '' }
      })
    },
    editClick (data) {
      this.create({ designator: 'applicant-questions-form-modal', component_name: 'QuestionsForm', data, resource_type: 'Applicant', resource_id: this.applicant_id, modal_title: data.info.applicant_text })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
